function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * @class documentsUploadDropzone
 *
 */
import React, { useEffect } from 'react';
import Dropzone from 'react-dropzone';
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { v4 as uuidV4 } from 'uuid';
import moment from 'moment';
import entityComposition from '../common/classes/entityComposition';
import Icon from '../common/containers/icon';
import fileProcessor from '../../utils/fileProcessor';
const DocumentsUploadDropzone = ({
  document,
  documentActions: {
    saveAllSuccess,
    create
  },
  notificationActions,
  userID,
  defaultTags,
  defaultJobs
}) => {
  const {
    progress,
    loading,
    error,
    pendingDocs,
    lastUploadedDocs,
    failedToUpload
  } = document;
  const {
    upload
  } = notificationActions;
  useEffect(() => {
    // If progress is at 95% and the documents are not already saving (loading)
    // then call serverSaveAll with the pending documens

    if (progress && !loading && !error && progress === 95) {
      // If we've got to this point, all files have been uploaded to S3 and saved to
      // the DB and/or their respective redux store
      saveAllSuccess();
    } else if (progress // var defined
    && !loading // not loading
    && !error // no errors
    && progress === 100 // document upload is complete
    ) {
      upload({
        files: lastUploadedDocs,
        failedToUpload
      });
    }
  }, [error, failedToUpload, lastUploadedDocs, loading, pendingDocs, progress, saveAllSuccess, upload]);
  const handleDrop = async filesToUpload => {
    // An empty list is returned if no pdf files were in the selected files
    if (filesToUpload.length === 0) {
      // Selection of other file types is not allowed in the upload window,
      // but it is possible with drag and drop
      return notificationActions.error({
        message: 'Only .PDF or .pdf files are allowed, please retry your upload with pdf file(s).',
        id: 'invalid_file_type'
      });
    }

    // NOTE: Dropzone is not supposed to allow any file types other than pdf.
    // That said, it trusts the suffix, fileProcessor will check the buffer for type.

    const createdDate = moment().utc().format('YYYY-MM-DD HH:mm:ss');
    const filePromises = filesToUpload.map(async file => {
      try {
        const hashString = await fileProcessor.detectFileAndCreateMD5Hash(file);
        return {
          id: uuidV4().toUpperCase(),
          cloudDocumentID: uuidV4().toUpperCase(),
          remotePath: uuidV4().toUpperCase(),
          hashString
        };
      } catch (processingFailure) {
        notificationActions.error({
          autoClose: 10000,
          message: processingFailure,
          id: 'invalid_file_type'
        });
        throw processingFailure;
      }
    });
    const ids = await Promise.all(filePromises);
    return create(ids, createdDate, filesToUpload, defaultTags, defaultJobs, userID);
  };

  // Need to disable the dropzone while uploading files
  const preventUpload = !(progress === 100 || progress < 0);

  // Display different text when the user has already uploaded files
  const buttonText = progress > 95 ? 'Upload More PDF Files' : 'Upload PDF Files';

  // Build the upload dropzone and button
  return /*#__PURE__*/React.createElement(Dropzone, {
    className: "t-dud-dropzone",
    onDrop: preventUpload ? () => {} : handleDrop,
    noClick: preventUpload,
    accept: {
      'application/pdf': ['.pdf']
    }
  }, ({
    getInputProps,
    getRootProps
  }) => /*#__PURE__*/React.createElement("div", getRootProps(), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    className: "form-control t-dud-upload",
    style: {
      marginBottom: '15px'
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "plus"
  }), " ", buttonText), /*#__PURE__*/React.createElement("input", _objectSpread(_objectSpread({}, getInputProps()), {}, {
    className: "t-dud-input-file"
  }))));
};
DocumentsUploadDropzone.propTypes = {
  document: PropTypes.shape({
    progress: PropTypes.number,
    loading: PropTypes.bool,
    pendingDocs: PropTypes.arrayOf(PropTypes.shape({})),
    failedToUpload: PropTypes.arrayOf(PropTypes.shape({})),
    lastUploadedDocs: PropTypes.arrayOf(PropTypes.shape({})),
    error: PropTypes.string
  }).isRequired,
  documentActions: PropTypes.shape({
    serverSaveAll: PropTypes.func,
    saveAllSuccess: PropTypes.func,
    create: PropTypes.func
  }).isRequired,
  // document redux actions
  defaultTags: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  // props from parent
  defaultJobs: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  // props from parent
  userID: PropTypes.string.isRequired,
  notificationActions: PropTypes.shape({
    error: PropTypes.func,
    upload: PropTypes.func
  }).isRequired
};
export { DocumentsUploadDropzone as TestDocumentsUploadDropzone };
export default entityComposition(DocumentsUploadDropzone, ['document'], {
  userID: state => state.login.user.user_id
}, ['notification']);